module.exports = __webpack_public_path__ + "static/media/left-medial-nonflexion.50433a86.png";